import React from "react";
import styles from "./Header.module.scss";
import Button from "../Button/Button";
import LazyImage from "../LazyImage/LazyImage";
import cn from "classnames";

const HeaderBanner: React.FC = () => {
    return (
        <div className={styles.headerBanner}>
            <div className={styles.headerTextWrap}>
                <h1 className={styles.headerTitle}>
                    Проект для вашего личного благополучия
                </h1>
                <p className={styles.headerText}>
                    Оформите «Life Care» и получите комплексные решения от лидера рынка
                </p>
                <Button href="#services"
                        isLink={true}
                        className={styles.headerButton}
                        classButton="redButton"
                >
                    Узнать больше
                </Button>
                <LazyImage className={cn("img-fluid", styles.headerImage)}
                           src="./assets/images/general/headerBanner.png"
                />
            </div>
        </div>
    );
}

export default HeaderBanner;
